import { ANIMATE_DELAY } from "src/libs/interfaces/animated"
import { IDataContentContainer } from "./SectionDataFeed"
import { useRef } from "react"
import { useAnimated } from "src/modules/pe-landing-module/hooks/useAnimated"
import { useAnimatedStyle } from "src/modules/pe-landing-module/hooks/useAnimatedStyle"

export const DataContentAnimateContainer = (props: IDataContentContainer) : JSX.Element => {
    const section = props.section || {} 
    
    const animated_delay =  section.animated_delay === ANIMATE_DELAY.WATERFALL
        ?
        props.i === 0 ? "" : props.i
        :
        section.animated_delay || ""
    const ref = useRef(null)
    useAnimated( ref, animated_delay )
      
    /* css class .landing-edit-cont - edit.select container for get bounds */
    const animate   = useAnimatedStyle(section, props.i)
    
    /** Не работает в карусели контентов */
    const width = !!props.proportia ? `${props.proportia}%` : undefined

    if(!props.section) {
        // return <></>
    }

    return <div 
        className={`landing-section-data-animation landing-edit-cont ${animate} ${props.className}`} 
        style={{ ...props.style, width, maxWidth: width }}
        data-proportia={ props.proportia }
        ref={ref}
    >
        {props.children}
    </div>
}